import logger from "./logService";
import { toast } from "react-toastify";

import axios from "../utils/scripts/axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

axios.interceptors.response.use(null, (error) => {
  if (error?.response) {
    logger(error);

    if (error?.message === "Network Error") {
      toast.info("Session has been expired. Please refresh the window!");
    } else if (error.response.status === 500) {
      toast.error("Unexpected error; Please check the logs!");
    } else if (error.response.status >= 300 && error.response.status < 500) {
      toast.warn(error.response.data ?? "Bad Request; Please try again!");
    }
  }

  return Promise.reject(error);
});

export function setAccessToken(jwt) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;

  localStorage.setItem("x-auth-token", jwt);
}

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
};

export default http;
